import { BaseModel } from "../base.model";

export class QuestionGroup extends BaseModel {
  id: number;
  name: string;
  description: string;
}
